import React from 'react';
import Options from "../../../shop/ai/options.jsx";
import Accept_orders from "./accept_orders.jsx";
import History_accept from "./accept_history.jsx";
import Cash_diary from "../../../nhatkyorders.jsx";

const HistoryHome = ({ slug_3, slug_4 }) => {
    return (
        <>
            {slug_3 == 'home' && (
                <Options category="p2p_mmo_history" />
            )}
            {slug_3 == 'cash_diary' && (
                <Cash_diary category_main={'p2p_mmo'} />
            )}
            {slug_3 == 'accept' && slug_4 == 'home' && (
                <Options category="accept_home" />
            )}
            {slug_3 == 'accept' && slug_4 == 'approve' && (
                <Accept_orders />
            )}
            {slug_3 == 'accept' && slug_4 == 'history' && (
                <History_accept />
            )}
            {slug_3 == 'nhatkyorders' && (
                <Cash_diary category_main={'p2p_mmo'} />
            )}
        </>
    );
};

export default HistoryHome;
